import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { CapturePage } from '@/pages/capture/CapturePage'
import { FxAlert } from '@/components/fx'

/**
 * The capture build. No session, no query cache, no auth provider — a token
 * link and a camera. Keeping it this thin is what lets it be a PWA someone
 * opens on a building site.
 */
export function CaptureApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/upload/:token" element={<CapturePage />} />
        <Route
          path="*"
          element={
            <main className="mx-auto w-full max-w-[520px] p-4">
              <FxAlert tone="info" title="Kein Upload-Link">
                Bitte den Link oder QR-Code öffnen, den Sie bekommen haben.
              </FxAlert>
            </main>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
